var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamilyIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 212.49 314.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#444;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 102.16,
    cy: 190.29,
    r: 24.45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 35.72,
    cy: 87.19,
    r: 33.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.27,249.92a37,37,0,0,1,14.15-29.09,43.88,43.88,0,0,1-.18-60.89,24.86,24.86,0,0,0-23.65-17.39H24.84A24.86,24.86,0,0,0,0,167.39v112.9A182.13,182.13,0,0,0,56.27,307.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.83,312.45a189.18,189.18,0,0,0,46.83,1,2.32,2.32,0,0,0,2.69-2.71q.39-28.61-.11-57.21c-.08-4.63-.26-9.51-2.72-13.43-2.64-4.19-7.54-6.54-12.46-7.22-8.5-1.2-27.43-1.33-33.52,5.95-3.36,4-3.54,9.7-3.57,14.94q-.09,27.71-.19,55.4a2.74,2.74,0,0,0,3,3.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.25,190.29a44,44,0,0,1-12.34,30.53A37.38,37.38,0,0,1,148,249.92v59.7a182,182,0,0,0,64.46-29.33V134.89a31.1,31.1,0,0,0-31.08-31H155.73a31.07,31.07,0,0,0-31,31v17.6a44.07,44.07,0,0,1,21.54,37.81Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 168.59,
    cy: 41.21,
    r: 41.21,
    transform: "translate(-4.88 46.5) rotate(-15.48)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyIc);
export default __webpack_public_path__ + "static/media/family-ic.f53432e65b0c504d15101b813d776483.svg";
export { ForwardRef as ReactComponent };